import { render } from "./users-index.vue?vue&type=template&id=0cd50ce6&scoped=true"
import script from "./users-index.vue?vue&type=script&lang=js"
export * from "./users-index.vue?vue&type=script&lang=js"

import "./users-index.vue?vue&type=style&index=0&id=0cd50ce6&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0cd50ce6"]])

export default __exports__